module.exports = __webpack_public_path__ + "static/media/intro_wheel-old.25b405fe.png";